exports = module.exports = require("../../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/credibility.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/credibility.component.scss
// module chunks = main